import { AutomationSource } from 'api/automations';

export const refToAutomationSource = (refType: string): AutomationSource =>
  ({
    phase: AutomationSource.ProjectPhaseTemplate,
    task: AutomationSource.TaskTemplate,
  }[refType] as AutomationSource);
